import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import TablePagination from "@mui/material/TablePagination";
import {
  Select,
  MenuItem,
  Input,
  IconButton,
  TextField,
  CircularProgress,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import InputAdornment from "@mui/material/InputAdornment";
import axios from "axios";
import FormControl from "@mui/material/FormControl";
import DatePicker from "react-datepicker";
import { ReactComponent as SortDown } from "../../assets/images/SortDown.svg";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import "react-datepicker/dist/react-datepicker.css";
import Header from "../dashboard/Header";
import Loading from "../Loading";
import OwnerPartRequestDialog from "./OwnerPartRequestDialog";
import OwnerPartCreationDialog from "./OwnerPartCreationDialog";
import "../../styles/ownerPartRequest.css";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import { ReactComponent as SearchIcon } from "../../assets/images/SearchIcon.svg";
import { ReactComponent as DatePickerIcon } from "../../assets/images/DatePickerIcon.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { automationHttpRequest } from "../../api/httpRequests";
import OwnerModificationDialog from "./OwnerModificationDialog";
import MassApproveRejectDialog from "./MassApproveRejectDialog";
import { ToastContainer, toast } from "react-toastify";
import PartRequestFilter from "../dashboard/PartRequestFilter";
import Popover from "@mui/material/Popover";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#FAF0F0",
    color: "rgb(198, 0, 61)",
    fontSize: "15px",
    fontWeight: "600",
    fontFamily: "Verdana",
    border: "2px solid #ccc", // Add border style
    borderBottom: "2px solid #BDBDBD", // Add bottom border style
    padding: "32px 20px",
    position: "sticky",
    top: 0,
    zIndex: 2,
    minWidth: "220px",
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: "red",
    border: "1px solid #BDBDBD", // Add border style
    borderBottom: "2px solid #BDBDBD", // Add bottom border style
  },
}));

const StyledTable = styled(Table)({
  border: "1px solid #BDBDBD",
});

const OwnerPartRequestHistory = () => {
  const [page, setPage] = useState(0);
  const [maxRows, setMaxRows] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedOption, setSelectedOption] = useState("");
  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [partRequestNumber, setPartRequestNumber] = useState();
  const [partRequestDialogOpen, setPartRequestDialogOpen] = useState(false);
  const [partRequestDetails, setPartRequestDetails] = useState();
  const [dfDetais, setDfDetais] = useState();
  const [dialogLoading, setDialogLoading] = useState(false);
  const [materialgroups, setMaterialgroups] = useState([]);
  const [partCreationDialogOpen, setPartCreationDialogOpen] = useState(false);
  const [partCreationDetails, setPartCreationDetails] = useState();
  const [partModificationDialogOpen, setPartModificationDialogOpen] =
    useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [column_Name, setColumnName] = React.useState("");
  const [order, setOrder] = useState("desc");
  const [filterValues, setFilterValues] = useState({});
  const [selectedFilterValues, setSelectedFilterValues] = useState({});
  const [orderBy, setOrderBy] = useState("");
  const [searchFilterOPen, setSearchFilterOpen] = useState(false);
  const [partModificationDetails, setPartModificationDetails] = useState();
  const [actionType, setActionType] = useState([
    "Extension",
    "Modification",
    "Creation",
  ]);
  const [updateTableData, setUpdateTableData] = useState([]);
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [massRequestDialog, setMassRequestDialog] = useState(false);
  const [massloading, setMassLoading] = React.useState(false);
  const [selectMembers, setSelectMembers] = useState([]);
  const [attributeDetails, setAttributesDetails] = useState([]);
  const [modifyLoader, setModifyLoader] = useState(false);
  const [modifyLoaderReject, setModifyLoaderReject] = useState(false);
  const [editableMaterialNumbers, setEditableMaterialNumbers] = useState({});
  const [columnFilters, setColumnFilters] = useState({});

  useEffect(() => {
    localStorage.setItem("request_id", JSON.stringify([]));
    localStorage.setItem("material_number", JSON.stringify([]));
    localStorage.setItem("date_of_submission", JSON.stringify([]));
    localStorage.setItem("request_type", JSON.stringify([]));
    localStorage.setItem("submitted_by", JSON.stringify([]));
    localStorage.setItem("plant_name", JSON.stringify([]));
    localStorage.setItem("status", JSON.stringify([]));
  }, []);

  useEffect(() => {
    if (tableData?.length) {
      const data = tableData?.map((val, index) => {
        return { ...val, checked: false };
      });
      setUpdateTableData(data);
      setEditableMaterialNumbers((prev) => {
        const next = {};

        data.forEach((row) => {
          if (row.request_type === "Creation" && row.status === "Approved") {
            next[row.request_id] =
              prev[row.request_id] ?? row.material_number ?? "";
          }
        });

        return next;
      });
    } else {
      setUpdateTableData([]);
      setEditableMaterialNumbers({});
    }
  }, [tableData]);
  const [partModificationType, setPartModificationType] = useState();

  useEffect(() => {
    fetchPartRequestHistory();
  }, [
    actionType,
    fromDate,
    toDate,
    page,
    rowsPerPage,
    order,
    orderBy,
    selectedFilterValues,
  ]);

  const handleFilterData = (data) => {
    let filterResult = {};
    if (data?.request_id) {
      filterResult.request_id = data?.request_id || [];
    }
    if (data?.material_number) {
      filterResult.material_number = data?.material_number || [];
    }
    if (data?.date_of_submission) {
      filterResult.date_of_submission = data?.date_of_submission || [];
    }
    if (data?.request_type) {
      filterResult.request_type = data?.request_type || [];
    }
    if (data?.submitted_by) {
      filterResult.submitted_by = data?.submitted_by || [];
    }
    if (data?.plant_name) {
      filterResult.plant_name = data?.plant_name || [];
    }
    if (data?.status) {
      filterResult.status = data?.status || [];
    }
    return filterResult;
  };

  const filteredColumns = {
    "Request ID": "request_id",
    "Material Number": "material_number",
    "Date of Submission": "date_of_submission",
    "Request Type": "request_type",
    "Submitted by": "submitted_by",
    "Requested for plant": "plant_name",
    Status: "status",
  };

  const buttonStyles = {
    fontFamily: "Verdana", // Common font family
    fontSize: "18px", // Common font size
    color: "#c6003d",
    padding: "10px",
  };

  const fetchPartRequestHistory = async () => {
    setLoading(true);

    try {
      const response = await automationHttpRequest.post(
        "/logbook/",
        {
          request_type: actionType,
          from_date: handleDateFormat(fromDate)
            ? handleDateFormat(fromDate)
            : "",
          to_date: handleDateFormat(toDate) ? handleDateFormat(toDate) : "",
          sort_order: order,
          sort_column: filteredColumns[orderBy],
          page_size: rowsPerPage,
          page: page + 1,
          ...selectedFilterValues,
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
        },
      );

      if (response?.data?.status) {
        setTableData(response?.data?.data?.data);
        setMaxRows(response?.data?.data?.total_count);
        setLoading(false);
        const filterResult = handleFilterData(response?.data?.data);
        setFilterValues(filterResult);
        setAnchorEl(null);
      }
    } catch (error) {
      // Handle errors
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleSearchfilterOpen = (event, col_name) => {
    setSearchFilterOpen(true);
    setAnchorEl(event.currentTarget);
    setColumnName(col_name);
  };

  const handleFiltersearch = (val) => {
    setSelectedFilterValues(val);
    setPage(0);
  };

  const handleColumnFilterChange = (columnKey, value) => {
    setColumnFilters((prev) => ({ ...prev, [columnKey]: value }));
  };

  const filteredTableData = updateTableData.filter((row) =>
    Object.entries(columnFilters).every(
      ([key, val]) =>
        !val.trim() ||
        String(row[key] ?? "")
          .toLowerCase()
          .includes(val.trim().toLowerCase()),
    ),
  );

  const handleClose = () => {
    setAnchorEl(null);
    setSearchFilterOpen(false);
  };

  const handleRequestSort = (property, orderValue) => {
    setOrder(orderValue);
    setOrderBy(property);
  };

  const handleRequest = (value, type) => {
    if (type === "Extension") {
      handlePartRequestDetails(value);
    }
    if (type === "Creation") {
      handlePartCreationDetails(value);
    }
    if (type === "Modification") {
      handlePartModificationDetails(value);
    }
  };

  const handlePartModificationDetails = (value) => {
    setPartRequestNumber(value);
    setPartModificationDialogOpen(true);
    const handlePartCreation = async (value) => {
      if (value) {
        setDialogLoading(true);
        try {
          const response = await automationHttpRequest.post(
            "/modification_details_for_data_owner/",
            { request_id: value.toString() },
            {
              headers: {
                session_id: localStorage.getItem("session_id"),
                userEmail: localStorage.getItem("MRO_user_email"),
              },
              params: {},
            },
          );
          if (response?.data?.status) {
            setDialogLoading(false);
            const modificationData = response?.data?.data;
            const modificationRow = modificationData?.[0] || {};
            const normalizedComment =
              modificationRow?.modification_comment ||
              modificationRow?.dataowner_extension_comment ||
              modificationRow?.data_owner_extension_comment ||
              response?.data?.dataowner_extension_comment ||
              response?.data?.data_owner_extension_comment ||
              "";
            setPartModificationDetails({
              ...modificationRow,
              dataowner_extension_comment: normalizedComment,
              data_owner_extension_comment: normalizedComment,
              modification_comment:
                modificationRow?.modification_comment || normalizedComment,
            });
            setPartModificationType(response?.data?.type);
          }
        } catch (error) {
          setDialogLoading(false);
          toast.error("Unable to process the request. Please try again!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 800,
          });
        }
      }
    };
    handlePartCreation(value);
    setPartModificationDialogOpen(true);
  };

  const handlePartRequestDetails = (value) => {
    setPartRequestNumber(value);
    const handlePartRequest = async (value) => {
      if (value) {
        setDialogLoading(true);
        try {
          const response = await automationHttpRequest.post(
            "/dataOwnerExtention/",
            { request_id: value.toString() },
            {
              headers: {
                session_id: localStorage.getItem("session_id"),
                userEmail: localStorage.getItem("MRO_user_email"),
              },
              params: {},
            },
          );
          if (response?.data?.status) {
            const extensionData = response?.data?.data;
            const extensionRow = extensionData?.data?.[0] || {};
            const normalizedComment =
              extensionRow?.dataowner_extension_comment ||
              extensionRow?.data_owner_extension_comment ||
              extensionData?.dataowner_extension_comment ||
              extensionData?.data_owner_extension_comment ||
              extensionData?.df_data?.dataowner_extension_comment ||
              extensionData?.df_data?.data_owner_extension_comment ||
              "";
            setPartRequestDetails({
              ...extensionRow,
              dataowner_extension_comment: normalizedComment,
              data_owner_extension_comment: normalizedComment,
            });
            setDfDetais({
              ...(extensionData?.df_data || {}),
              dataowner_extension_comment: normalizedComment,
              data_owner_extension_comment: normalizedComment,
            });
            setDialogLoading(false);
          }
        } catch (error) {
          setDialogLoading(false);
          toast.error("Unable to process the request. Please try again!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 800,
          });
        }
      }
    };
    handlePartRequest(value);
    setPartRequestDialogOpen(true);
  };

  const handlePartCreationDetails = (value) => {
    setPartRequestNumber(value);
    const handlePartCreation = async (value) => {
      if (value) {
        setDialogLoading(true);
        try {
          const response = await automationHttpRequest.post(
            "/get_Data_Owner_History_For_Creation/",
            { request_id: value.toString() },
            {
              headers: {
                session_id: localStorage.getItem("session_id"),
                userEmail: localStorage.getItem("MRO_user_email"),
              },
              params: {},
            },
          );
          if (response?.data?.status) {
            setDialogLoading(false);
            setPartCreationDetails(response?.data?.data[0]);

            // ✅ Fetch material group data here
            await fetchMaterialGroup();

            setAttributesDetails(response?.data?.all_attribute_data);
          }
        } catch (error) {
          setDialogLoading(false);
          toast.error("Unable to process the request. Please try again!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 800,
          });
        }
      }
    };
    handlePartCreation(value);
    setPartCreationDialogOpen(true);
  };

  const fetchMaterialGroup = async () => {
    try {
      const response = await automationHttpRequest.get("/get_materialgroup/", {
        headers: {
          session_id: localStorage.getItem("session_id"),
          userEmail: localStorage.getItem("MRO_user_email"),
        },
      });
      if (response?.data?.status) {
        setMaterialgroups(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching nouns:", error);
    }
  };

  const handleMassUploaded = () => {
    setModifyLoader(true);
    const selectedApprovedRequestIdsCsv = selectedRequests.join(",");
    console.log(
      "Selected Requests for Mass Upload:",
      selectedApprovedRequestIdsCsv,
    );

    const handlePartCreation = async () => {
      try {
        const response = await automationHttpRequest.post(
          "/extension_modification_upload_mass/",
          {
            request_id: selectedApprovedRequestIdsCsv,
            data_owner_extension_comment: "",
          },
          {
            headers: {
              session_id: localStorage.getItem("session_id"),
              userEmail: localStorage.getItem("MRO_user_email"),
            },
            params: {},
          },
        );
        if (response?.data?.status) {
          const selectedRequestIdSet = new Set(selectedRequests);

          setUpdateTableData((prev) =>
            prev.map((row) =>
              selectedRequestIdSet.has(row.request_id)
                ? { ...row, status: "Uploaded", checked: false }
                : row,
            ),
          );

          setTableData((prev) =>
            prev.map((row) =>
              selectedRequestIdSet.has(row.request_id)
                ? { ...row, status: "Uploaded" }
                : row,
            ),
          );

          setSelectedRequests([]);
          setSelectMembers([]);
          setModifyLoader(false);
          toast.success(
            `Mass Approved Request IDs ${selectedApprovedRequestIdsCsv}`,
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            },
          );
        }
      } catch (error) {
        setModifyLoader(false);
        toast.error("Unable to process the request. Please try again!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    };
    if (selectedRequests.length < 1) {
      setModifyLoader(false);
      toast.error("Select at least one ID and try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    } else {
      handlePartCreation();
    }
    setMassRequestDialog(true);
  };

  const handlePartRequestReject = async () => {
    setModifyLoaderReject(true);
    const selectedApprovedRequestIdsCsv = selectedRequests.join(",");
    const handlePartCreation = async () => {
      try {
        const response = await automationHttpRequest.post(
          "/extension_mass_reject11/",
          {
            request_id: [...selectedRequests],
            data_owner_extension_comment: "",
          },
          {
            headers: {
              session_id: localStorage.getItem("session_id"),
              userEmail: localStorage.getItem("MRO_user_email"),
            },
            params: {},
          },
        );
        if (response?.data?.status) {
          fetchPartRequestHistory();
          setModifyLoaderReject(false);
          toast.success(
            `Mass Rejected Request IDs ${selectedApprovedRequestIdsCsv}`,
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 1000,
            },
          );
        }
      } catch (error) {
        setModifyLoaderReject(false);
        setDialogLoading(false);
        toast.error("Unable to process the request. Please try again!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    };
    if (selectedRequests.length < 1) {
      setModifyLoaderReject(false);
      toast.error("Select at least one ID and try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    } else {
      await handlePartCreation();
    }
    // Add 'await' here to wait for the asynchronous function to complete
  };

  const handleDateFormat = (value) => {
    if (!value) {
      return "";
    }
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const inputDate = new Date(value);
    const formattedDate = formatDate(inputDate);
    return formattedDate;
  };

  const options = ["Extension", "Modification", "Creation"];

  const handleSelectChange = (event) => {
    const selectedValues = event.target.value;
    const updatedSelectedOptions = selectedValues.includes("All")
      ? options.filter((option) => option !== "All")
      : selectedValues;
    setSelectedOptions(updatedSelectedOptions);
    setActionType(updatedSelectedOptions);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    if (event.target.value === maxRows) {
      setPage(0);
    }
    setPage(0);
  };

  const handleApprove = () => {
    handleMassUploaded();
  };

  const handleReject = () => {
    handlePartRequestReject();
  };

  const handleDialogClose = () => {
    setPartRequestDialogOpen(false);
  };

  const handleCreationDialogClose = () => {
    setPartCreationDialogOpen(false);
  };

  const handleModificationDialogClose = () => {
    setPartModificationDialogOpen(false);
  };

  const handleRequestStatusUpdate = (requestId, status) => {
    setUpdateTableData((prev) =>
      prev.map((row) =>
        row.request_id === requestId ? { ...row, status, checked: false } : row,
      ),
    );

    setTableData((prev) =>
      prev.map((row) =>
        row.request_id === requestId ? { ...row, status } : row,
      ),
    );

    setSelectedRequests((prev) => prev.filter((id) => id !== requestId));
    setSelectMembers((prev) =>
      prev.filter((item) =>
        typeof item === "object" && item !== null
          ? item.request_id !== requestId
          : item !== requestId,
      ),
    );
  };

  const handleMassDialogClose = () => {
    setMassRequestDialog(false);
    setSelectedRequests([]);
    setSelectMembers([]);
    fetchPartRequestHistory();
  };

  const isSelectableRequestType = (requestType) =>
    requestType === "Modification" || requestType === "Extension";

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const approvedRows = updateTableData.filter(
        (val) =>
          val.status === "Approved" &&
          isSelectableRequestType(val.request_type),
      );
      const newSelected = approvedRows.map((val) => val.request_id);
      const data = updateTableData?.map((val, index) => {
        return {
          ...val,
          checked:
            val.status === "Approved" &&
            isSelectableRequestType(val.request_type),
        };
      });
      setUpdateTableData(data);
      setSelectedRequests(newSelected);
      setSelectMembers(newSelected);
      return;
    }
    const data = updateTableData?.map((val, index) => {
      return { ...val, checked: false };
    });
    setUpdateTableData(data);
    setSelectedRequests([]);
    setSelectMembers([]);
  };

  const handleChangeCheckBox = (e, data) => {
    if (
      data?.status !== "Approved" ||
      !isSelectableRequestType(data?.request_type)
    ) {
      return;
    }

    if (e.target.checked) {
      const checkedArray = updateTableData?.map((ele, index) => {
        if (ele?.request_id === data?.request_id) {
          return { ...ele, checked: true };
        } else {
          return { ...ele };
        }
      });
      const selectItems = checkedArray?.filter((val) => val.checked);
      setSelectMembers(selectItems);
      const newSelected = selectItems.map((val) => val.request_id);
      setSelectedRequests(newSelected);
      setUpdateTableData(checkedArray);
    } else {
      const checkedArray = updateTableData?.map((ele, index) => {
        if (ele?.request_id === data?.request_id) {
          return { ...ele, checked: false };
        } else {
          return { ...ele };
        }
      });
      const selectItems = checkedArray?.filter((val) => val.checked);
      setSelectMembers(selectItems);
      const newSelected = selectItems.map((val) => val.request_id);
      setSelectedRequests(newSelected);
      setUpdateTableData(checkedArray);
    }
  };

  const handleMaterialNumberChange = (requestId, value) => {
    setEditableMaterialNumbers((prev) => ({
      ...prev,
      [requestId]: value,
    }));
  };

  const handleMaterialNumberApply = async (requestId) => {
    const materialNumber = editableMaterialNumbers[requestId]?.trim() ?? "";
    const selectedRow = updateTableData.find(
      (row) => row.request_id === requestId,
    );

    try {
      const response = await automationHttpRequest.post(
        "/create_material_upload/",
        {
          request_id: requestId,
          material_number: materialNumber,
          dataowner_extension_comment: "",
          plant_id: selectedRow?.plant_id ?? "0",
          plant_name: selectedRow?.plant_name ?? "GENERIC",
          submitted_by:
            selectedRow?.submitted_by ||
            localStorage.getItem("MRO_user_email") ||
            "",
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
        },
      );

      if (response?.data?.status) {
        setUpdateTableData((prev) =>
          prev.map((row) =>
            row.request_id === requestId
              ? {
                  ...row,
                  material_number: materialNumber,
                  status: "Uploaded",
                  checked: false,
                }
              : row,
          ),
        );

        setTableData((prev) =>
          prev.map((row) =>
            row.request_id === requestId
              ? { ...row, material_number: materialNumber, status: "Uploaded" }
              : row,
          ),
        );

        setSelectedRequests((prev) => prev.filter((id) => id !== requestId));
        setSelectMembers((prev) =>
          prev.filter((item) =>
            typeof item === "object" && item !== null
              ? item.request_id !== requestId
              : item !== requestId,
          ),
        );

        toast.success(`Material Number updated for Request ID ${requestId}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 800,
        });
      } else {
        toast.error("Unable to update material number. Please try again!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    } catch (error) {
      toast.error("Unable to update material number. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const allRowsSelected =
    updateTableData.filter(
      (row) =>
        row.status === "Approved" && isSelectableRequestType(row.request_type),
    ).length > 0 &&
    selectedRequests.length ===
      updateTableData.filter(
        (row) =>
          row.status === "Approved" &&
          isSelectableRequestType(row.request_type),
      ).length;
  const hasPartialSelection =
    selectedRequests.length > 0 &&
    selectedRequests.length <
      updateTableData.filter(
        (row) =>
          row.status === "Approved" &&
          isSelectableRequestType(row.request_type),
      ).length;

  return (
    <>
      <div>
        <Header handleHideInsights={""} />
        <div style={{ margin: "20px" }}>
          {/* <div>
            <Typography className="approval">Approval Status</Typography>
          </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            {/* <div className="selectOption">
              <Typography className="selectHeading">
                Select Request Type
              </Typography>
              <FormControl sx={{ m: 1, width: "250px" }}>
                <Select
                  multiple
                  value={selectedOptions}
                  onChange={handleSelectChange}
                  IconComponent={() => (
                    <DropdownIcon
                      style={{
                        width: "20px",
                        position: "relative",
                        left: "-10px",
                      }}
                    />
                  )}
                  renderValue={(selected) => selected.join(", ")}
                  sx={{ height: "32px" }}
                >
                  {options.map((option) => (
                    <MenuItem key={option} value={option}>
                      <Checkbox
                        checked={selectedOptions.indexOf(option) > -1}
                      />
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div> */}

            {/* <div style={{ flex: 1 }}></div> */}
            {selectedRequests.length > 0 ? (
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  className={`actionButton${modifyLoader ? " loading" : ""}`}
                  onClick={handleApprove}
                  style={buttonStyles}
                  disabled={modifyLoader}
                >
                  {modifyLoader ? (
                    <CircularProgress size={20} sx={{ color: "#c6003d" }} />
                  ) : (
                    "Uploaded"
                  )}
                </button>
              </div>
            ) : null}
            <div
              style={{
                // position: "relative",
                margin: "0px 20px",
                display: "flex",
              }}
            >
              {/* <IconButton className="buttonIcon">
                <SearchIcon />
              </IconButton>
              <Input
                fullWidth
                disableUnderline
                // value={search_value}
                placeholder="Search history"
                className="searchInputField"
                // onChange={handleInputChange}
                // onKeyDown={handleKeyPress}
              /> */}
            </div>
            {/* <div style={{ display: "flex", gap: "10px" }}>
              <div>
                <label htmlFor="fromDate" className="datePickerLabel">
                  From{" "}
                </label>
                <DatePicker
                  selected={fromDate}
                  onChange={(newDate) => setFromDate(newDate)}
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  customInput={
                    <div style={{ position: "relative" }}>
                      <DatePickerIcon className="datePickerIcon" />
                      <input
                        className="datePickerInput"
                        type="text"
                        value={
                          fromDate ? handleDateFormat(fromDate) : "Choose Date"
                        }
                        readOnly
                      />
                    </div>
                  }
                />
              </div>
              <div>
                <label htmlFor="toDate" className="datePickerLabel">
                  To{" "}
                </label>
                <DatePicker
                  selected={toDate}
                  onChange={(newDate) => setToDate(newDate)}
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  customInput={
                    <div style={{ position: "relative" }}>
                      <DatePickerIcon className="datePickerIcon" />
                      <input
                        className="datePickerInput"
                        type="text"
                        value={
                          toDate ? handleDateFormat(toDate) : "Choose Date"
                        }
                        readOnly
                      />
                    </div>
                  }
                />
              </div>
            </div> */}
          </div>
          <div>
            <Paper
              sx={{ width: "100%", mb: 2, border: "1px solid #BDBDBD" }}
              elevation={2}
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <TableContainer
                    sx={{
                      maxHeight: "600px",
                      overflow: "auto",
                      borderBottom: "1px solid #BDBDBD",
                    }}
                  >
                    <Table
                      stickyHeader
                      sx={{ minWidth: 750, border: "1px solid #BDBDBD" }}
                      aria-labelledby="tableTitle"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            padding="checkbox"
                            sx={{
                              backgroundColor: "#FAF0F0 !important",
                              position: "sticky",
                              top: 0,
                              color: "rgb(198, 0, 61)",
                              fontSize: "14px",
                              fontWeight: "700",
                              fontFamily: "Verdana",
                              borderRight: "1px solid #BDBDBD",
                              zIndex: 3,
                              minWidth: "72px",
                            }}
                          >
                            <Checkbox
                              checked={allRowsSelected}
                              indeterminate={hasPartialSelection}
                              onChange={handleSelectAllClick}
                              inputProps={{
                                "aria-label": "select all request rows",
                              }}
                            />
                          </TableCell>
                          {Object.keys(filteredColumns).map(
                            (columnName, index) => (
                              <TableCell
                                key={columnName}
                                align="center"
                                padding="normal"
                                sx={{
                                  backgroundColor: "#FAF0F0 !important",
                                  position: "sticky",
                                  top: 0,
                                  color: "rgb(198, 0, 61)",
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  fontFamily: "Verdana",
                                  borderRight:
                                    index <
                                    Object.keys(filteredColumns).length - 1
                                      ? "1px solid #BDBDBD"
                                      : "none",
                                }}
                                className={
                                  columnName === "Request ID"
                                    ? "fixed-column"
                                    : null
                                }
                              >
                                <div>
                                  {columnName === "Date of Submission"
                                    ? "Date Submitted"
                                    : columnName}
                                  <IconButton
                                    style={{
                                      position: "relative",
                                      left: "10px",
                                      top: "0px",
                                      zIndex: 2,
                                      fontSize: "0px",
                                    }}
                                    onClick={(e) =>
                                      handleSearchfilterOpen(e, columnName)
                                    }
                                  >
                                    <SortDown style={{ cursor: "pointer" }} />
                                  </IconButton>
                                </div>
                              </TableCell>
                            ),
                          )}
                        </TableRow>
                        {/* inline filter row */}
                        <TableRow>
                          <TableCell
                            padding="checkbox"
                            sx={{
                              backgroundColor: "#FAF0F0 !important",
                              position: "sticky",
                              top: 57,
                              zIndex: 3,
                              borderRight: "1px solid #BDBDBD",
                            }}
                          />
                          {Object.entries(filteredColumns).map(
                            ([columnName, columnKey], index) => (
                              <TableCell
                                key={columnKey}
                                sx={{
                                  backgroundColor: "#FAF0F0 !important",
                                  position: "sticky",
                                  top: 57,
                                  zIndex: 3,
                                  padding: "4px 8px",
                                  borderRight:
                                    index <
                                    Object.keys(filteredColumns).length - 1
                                      ? "1px solid #BDBDBD"
                                      : "none",
                                }}
                              >
                                <input
                                  type="text"
                                  value={columnFilters[columnKey] || ""}
                                  onChange={(e) =>
                                    handleColumnFilterChange(
                                      columnKey,
                                      e.target.value,
                                    )
                                  }
                                  placeholder={`Search...`}
                                  style={{
                                    width: "100%",
                                    height: "30px",
                                    padding: "0 8px",
                                    border: "1px solid #cbc3c3",
                                    borderRadius: "4px",
                                    fontFamily: "Verdana",
                                    fontSize: "12px",
                                    outline: "none",
                                    boxSizing: "border-box",
                                  }}
                                />
                              </TableCell>
                            ),
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {filteredTableData.map((row, index) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row["Request ID"]}
                            selected={Boolean(row.checked)}
                          >
                            <TableCell
                              padding="checkbox"
                              align="center"
                              sx={{
                                border: "1px solid #BDBDBD",
                                borderRight: "1px solid #BDBDBD",
                              }}
                            >
                              <Checkbox
                                checked={Boolean(row.checked)}
                                disabled={
                                  row.status !== "Approved" ||
                                  !isSelectableRequestType(row.request_type)
                                }
                                onChange={(event) =>
                                  handleChangeCheckBox(event, row)
                                }
                                inputProps={{
                                  "aria-label": `select request ${row.request_id}`,
                                }}
                              />
                            </TableCell>
                            {Object.values(filteredColumns).map(
                              (columnName, columnIndex) => (
                                <TableCell
                                  key={columnName}
                                  align="center"
                                  sx={{
                                    border: "1px solid #BDBDBD",
                                    fontFamily: "Verdana",
                                    textAlign: "center",
                                    borderRight:
                                      columnIndex <
                                      Object.values(filteredColumns).length - 1
                                        ? "1px solid #BDBDBD"
                                        : "none", // Add border-right
                                  }}
                                  className={
                                    columnName === "request_id"
                                      ? "fixed-column"
                                      : null
                                  }
                                >
                                  {columnName === "request_id" ? (
                                    <button
                                      style={{
                                        border: "0px",
                                        background: "transparent",
                                        color: "#C6003D",
                                        cursor: "pointer",
                                        fontWeight: 550,
                                        fontFamily: "Verdana",
                                      }}
                                      onClick={() =>
                                        handleRequest(
                                          row[columnName],
                                          row["request_type"],
                                        )
                                      }
                                    >
                                      {row[columnName]}
                                    </button>
                                  ) : columnName === "material_number" &&
                                    row.request_type === "Creation" &&
                                    row.status === "Approved" ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <TextField
                                        value={
                                          editableMaterialNumbers[
                                            row.request_id
                                          ] ?? ""
                                        }
                                        onChange={(event) =>
                                          handleMaterialNumberChange(
                                            row.request_id,
                                            event.target.value,
                                          )
                                        }
                                        size="small"
                                        variant="outlined"
                                        placeholder="Enter material number"
                                        sx={{
                                          minWidth: "180px",
                                          "& .MuiOutlinedInput-input": {
                                            padding: "8px 12px",
                                            fontFamily: "Verdana",
                                          },
                                        }}
                                      />
                                      <IconButton
                                        onClick={() =>
                                          handleMaterialNumberApply(
                                            row.request_id,
                                          )
                                        }
                                        disabled={
                                          (
                                            editableMaterialNumbers[
                                              row.request_id
                                            ]?.trim() ?? ""
                                          ).length < 8
                                        }
                                        aria-label={`apply material number for request ${row.request_id}`}
                                        sx={{ color: "#C6003D" }}
                                      >
                                        <ArrowForwardIcon />
                                      </IconButton>
                                    </div>
                                  ) : (
                                    row[columnName]
                                  )}
                                </TableCell>
                              ),
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <Popover
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <PartRequestFilter
                        filter_values={
                          filterValues?.[filteredColumns?.[column_Name]]
                        }
                        handleFiltersearch={handleFiltersearch}
                        column_Name={column_Name}
                        filterColumns={filteredColumns}
                        searchFilterOPen={searchFilterOPen}
                        handleSearchClose={handleClose}
                        handleRequestSort={handleRequestSort}
                      />
                    </Popover>
                  </TableContainer>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "0 16px", // Add padding
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Verdana",
                        marginLeft: "22px",
                      }}
                    >
                      {" "}
                      Total:{" "}
                      <span style={{ fontWeight: "600" }}>{maxRows}</span>{" "}
                      records
                    </Typography>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        15,
                        50,
                        { value: maxRows, label: "All" },
                      ]}
                      component="div"
                      count={maxRows}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </>
              )}
            </Paper>
          </div>
        </div>
      </div>
      {/* 
      <MassApproveRejectDialog
        open={massRequestDialog}
        closeDialog={handleMassDialogClose}
        dialogLoading={massloading}
        selectMembers={selectMembers}
      /> */}

      <OwnerPartRequestDialog
        open={partRequestDialogOpen}
        dialogData={partRequestDetails}
        closeDialog={handleDialogClose}
        partRequestNumber={partRequestNumber}
        dialogLoading={dialogLoading}
        dfDetais={dfDetais}
        fetchPartRequestHistory={fetchPartRequestHistory}
        onRequestStatusUpdate={handleRequestStatusUpdate}
      />
      <OwnerPartCreationDialog
        open={partCreationDialogOpen}
        dialogData={partCreationDetails}
        materialgroups={materialgroups}
        attributeDetails={attributeDetails}
        closeDialog={handleCreationDialogClose}
        partRequestNumber={partRequestNumber}
        dialogLoading={dialogLoading}
        fetchPartRequestHistory={fetchPartRequestHistory}
        onRequestStatusUpdate={handleRequestStatusUpdate}
      />
      <OwnerModificationDialog
        open={partModificationDialogOpen}
        dialogData={partModificationDetails}
        closeDialog={handleModificationDialogClose}
        partRequestNumber={partRequestNumber}
        modificationType={partModificationType}
        dialogLoading={dialogLoading}
        fetchPartRequestHistory={fetchPartRequestHistory}
        onRequestStatusUpdate={handleRequestStatusUpdate}
      />
    </>
  );
};

export default OwnerPartRequestHistory;
